import { render, staticRenderFns } from "./ModeSetting.vue?vue&type=template&id=6fb6c13a&scoped=true"
import script from "./ModeSetting.vue?vue&type=script&lang=js"
export * from "./ModeSetting.vue?vue&type=script&lang=js"
import style0 from "./ModeSetting.vue?vue&type=style&index=0&id=6fb6c13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6c13a",
  null
  
)

export default component.exports